export function isEmail(str: string | null) {
    if (!str) return false
    let re = /\S+@\S+\.\S+/
    return re.test(str)
}

export function isMobile(str: string | null) {
    if (!str) return false
    return /^\+/.test(str)
}
